import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../../shared/components/base-page.component';
import { FeaturesComponent } from './../Components/Features/FeaturesComponent';
import { HeroComponent } from '../Components/Hero/HeroComponent';

@Component({
    selector: 'index-page',
    standalone: true,
    imports: [HeroComponent, FeaturesComponent, ...BasePage.BaseImports],
    templateUrl: './HomePage.html',
    styleUrl: './HomePage.css',
})

export class HomePage implements BasePage, OnInit
{
    constructor()
    {
    }

    async ngOnInit()
    {
    }
}
